import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinearProgress } from '@zurich/ui/legacy/components';
import { Footer } from '@zurich/ui/legacy/templates';
import { styled } from '@zurich/ui/legacy/utils';
// TODO: figure out a better placement for this file!
// TODO: Improve layout height and min-height on mobile and Desktop in Kombination with the fixed and sticky header/sidebar
export const HEADER_HIGHT = '66px';
export const SIDEBAR_WIDTH = '100px';
export const Layout = ({ children, loading, HeaderComponent = null, SidebarComponent = null, footer = _jsx(Footer, {}), }) => (_jsxs(_Fragment, { children: [loading && _jsx(LoadingBarStyled, {}), _jsxs("div", { children: [HeaderComponent, _jsx(MainStyled, { children: _jsxs(ContainerStyled, { children: [SidebarComponent, _jsx(ContentStyled, { children: children }), _jsx(FooterStyled, { children: footer })] }) })] })] }));
const MainStyled = styled('div')({
    display: 'flex',
});
const ContainerStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.groupPrimary.aliceBlue,
    width: '100%',
    minHeight: `calc(100vh - ${SIDEBAR_WIDTH})`,
    [theme.breakpoints.down('md')]: {
        marginLeft: 'unset',
        minHeight: `calc(100vh - ${HEADER_HIGHT})`,
        height: '100%',
    },
}));
const ContentStyled = styled('div')(({ theme }) => ({
    marginLeft: '100px',
    width: `calc(100% - ${SIDEBAR_WIDTH})`,
    backgroundColor: theme.palette.groupPrimary.aliceBlue,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 2, //TODO refactoring Layout component- grid holy grail
    '& >:nth-of-type(2)': {
        flex: '1 1 auto',
    },
    [theme.breakpoints.down('lg')]: {
        width: '100%',
        marginLeft: 'unset',
    },
}));
const FooterStyled = styled('div')(({ theme }) => ({
    marginLeft: 'unset',
    [theme.breakpoints.up('lg')]: {
        marginLeft: '100px',
        width: `calc(100% - ${SIDEBAR_WIDTH})`,
    },
}));
const LoadingBarStyled = styled(LinearProgress)({
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 100,
    height: 3,
});
export default Layout;
